import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../Config/Actions/loadingActions";
import {
  apiCallAddUserArtistType,
} from "../../Core/Apicall";

function ArtisticModal({ show, handleClose, pageRefresh, editData }) {
  const [tagName, setTagName] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    if (editData != undefined) {
      setTagName(editData?.ArtistType);
    }
  }, [editData]);

  const handleSubmit = async () => {
    if (tagName.trim() === "") {
      alert("Please enter artistic tag name");
      return;
    }

    dispatch(setLoadingTrue());
    let param = {
      userArtistType: tagName,
    };

    if (editData) {
      param = {
        ...param,
        _id: editData._id,
      };
    }
    try {
      await apiCallAddUserArtistType(param);
      setTagName("");
      pageRefresh();
      handleClose();
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };

  const closeModal = () => {
    setTagName("");
    handleClose();
  };
  return (
    <div
      className={`modal-category ${show ? 'display-block' : 'display-none'}`}
      onClick={closeModal}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.65)',
        backdropFilter: 'blur(4px)',
        display: show ? 'flex' : 'none',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '500px',
          background: '#081B3A',
          borderRadius: '20px',
          padding: '25px',
          position: 'relative',
          border: '1px solid #1f4d99',
          boxShadow: '0 10px 30px rgba(0,0,0,0.4)'
        }}
      >
        <span
          onClick={closeModal}
          style={{
            position: 'absolute',
            right: '20px',
            top: '10px',
            color: '#fff',
            fontSize: '40px',
            cursor: 'pointer',
            lineHeight: 1
          }}
        >
          ×
        </span>

        <h2
          style={{
            textAlign: 'center',
            color: '#fff',
            fontSize: '32px',
            fontWeight: '700',
            marginBottom: '8px'
          }}
        >
          {editData ? "Edit Artistic Tag" : "Add Artistic Tag"}
        </h2>

        <p
          style={{
            textAlign: 'center',
            color: '#A9B6D3',
            fontSize: '14px',
            marginBottom: '25px'
          }}
        >
          Add a new Artistic Tag to organize your items
        </p>

        <div className="Category_name">
          <input
            type="text"
            value={tagName}
            onChange={(e) => setTagName(e.target.value)}
            placeholder="Enter Artistic Tag Name"
          />
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '25px'
          }}
        >
          <button style={{
            width: '180px',
            height: '48px',
            border: 'none',
            borderRadius: '10px',
            background: 'linear-gradient(90deg,#4F46E5,#3B82F6)',
            color: '#fff',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: '0.3s'
          }} onClick={handleSubmit}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default ArtisticModal;
